import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { NationalityAction } from "./nationality.action";
import { NationalityState } from "./nationality.model";

const INITIAL_STATE: NationalityState = {
	nationalities: [],
};

export const nationalityReducer = createReducer(
	INITIAL_STATE,
	on(NationalityAction.getAllSuccess, (state, { nationalities }) => updateState(state, { nationalities }))
);
